export const cutStrings = (string, length) => {
  string = String(string);

  if (string.length <= length) {
    return string;
  }

  return String(string).substring(0, length) + "...";
};
